import React from 'react';
import {
  BsFillCloudArrowDownFill,
  BsSearch,
  BsFillPenFill,
  BsFillTrashFill,
  BsBookHalf,
  BsFillXCircleFill,
  BsSave2Fill,
  BsPrinterFill,
  BsFillCheckCircleFill,
  BsLockFill,
  BsArrowLeftCircleFill,
  BsFillPlusCircleFill,
  BsArrowClockwise,
  BsShieldFillCheck,
  BsPersonCheckFill,
  BsKanban,
  BsJournalBookmarkFill,
  BsLayoutSidebarInsetReverse,
  BsTruck,
  BsEye,
} from 'react-icons/bs';
import {
  RiLogoutBoxRFill,
  RiLoginBoxFill,
  RiExchangeLine,
  RiTicket2Fill,
  RiFileTransferFill,
  RiCheckFill,
} from 'react-icons/ri';
import { IoSettingsOutline, IoBookmarks, IoAlertCircleSharp, IoCheckbox } from 'react-icons/io5';
import { HiDotsCircleHorizontal } from 'react-icons/hi';
import {
  FaAngleDoubleLeft,
  FaBook,
  FaBoxOpen,
  FaChevronCircleDown,
  FaExternalLinkAlt,
  FaFileAlt,
  FaFileImport,
  FaHourglass,
  FaLine,
  FaPaperPlane,
  FaQrcode,
  FaRegistered,
  FaTimes,
  FaUsers,
} from 'react-icons/fa';
import { MdWavingHand } from 'react-icons/md';
import { FiChevronRight } from 'react-icons/fi';
import { EditFilled } from '@ant-design/icons';
import { MdCancel } from 'react-icons/md';

/**
 * React Icons --> https://react-icons.github.io/react-icons/
 */
export const Icon = {
  download: (props) => <BsFillCloudArrowDownFill {...props} />,
  search: (props) => <BsSearch {...props} />,
  edit: (props) => <BsFillPenFill {...props} />,
  remove: (props) => <BsFillTrashFill {...props} />,
  view: (props) => <BsBookHalf {...props} />,
  clear: (props) => <BsFillXCircleFill {...props} />,
  cancel: (props) => <BsFillXCircleFill {...props} />,
  logout: (props) => <RiLogoutBoxRFill {...props} />,
  login: (props) => <RiLoginBoxFill {...props} />,
  save: (props) => <BsSave2Fill {...props} />,
  evernote: (props) => <FaBook {...props} />,
  print: (props) => <BsPrinterFill {...props} />,
  detail: (props) => <BsEye {...props} />,
  box: (props) => <FaBoxOpen {...props} />,
  hourglass: (props) => <FaHourglass {...props} />,
  truck: (props) => <BsTruck {...props} />,
  confirm: (props) => <BsFillCheckCircleFill {...props} />,
  times: (props) => <FaTimes {...props} />,
  paperPlane: (props) => <FaPaperPlane {...props} />,
  forgetPassword: (props) => <BsLockFill {...props} />,
  back: (props) => <BsArrowLeftCircleFill {...props} />,
  doubleLeft: (props) => <FaAngleDoubleLeft {...props} />,
  create: (props) => <BsFillPlusCircleFill {...props} />,
  reAct: (props) => <BsArrowClockwise {...props} />,
  recheck: (props) => <BsShieldFillCheck {...props} />,
  change: (props) => <RiExchangeLine {...props} />,
  line: (props) => <FaLine {...props} />,
  edit2: (props) => <EditFilled {...props} />,
  register: (props) => <BsPersonCheckFill {...props} />,
  settings: (props) => <IoSettingsOutline {...props} />,
  threeDots: (props) => <HiDotsCircleHorizontal {...props} />,
  downCircle: (props) => <FaChevronCircleDown {...props} />,
  bookmark: (props) => <IoBookmarks {...props} />,
  alert: (props) => <IoAlertCircleSharp {...props} />,
  checkboxSquare: (props) => <IoCheckbox {...props} />,
  wavingHand: (props) => <MdWavingHand {...props} />,
  external: (props) => <FaExternalLinkAlt {...props} />,
  cancel2: (props) => <MdCancel {...props} />,
  import: (props) => <FaFileImport {...props} />,
  ticket: (props) => <RiTicket2Fill {...props} />,
  transfer: (props) => <RiFileTransferFill {...props} />,
  check: (props) => <RiCheckFill {...props} />,

  /** MENU ICON */
  dashboard: (props) => <BsKanban {...props} />,
  todo: (props) => <BsJournalBookmarkFill {...props} />,
  formExample: (props) => <BsLayoutSidebarInsetReverse {...props} />,
  registered: (props) => <FaRegistered {...props} />,
  fileSearch: (props) => <FaFileAlt {...props} />,
  qrcode: (props) => <FaQrcode {...props} />,
  users: (props) => <FaUsers {...props} />,
};
export const StepIcon = () => {
  return <FiChevronRight size={20} style={{ color: 'grey' }} />;
};
